import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Skeleton — loading placeholder. Pencil eONf6.
 */
export const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-ia-elevated', className)}
      {...props}
    />
  ),
)
Skeleton.displayName = 'Skeleton'
